import { PropsWithChildren } from "react";
import { ContentWrapperProps } from "./ContentWrapper.props";
import { ContentWrapperStyles } from "./ContentWrapper.styles";

export const ContentWrapper = ({
  children,
  autoWidth,
  customSideMargin
}: PropsWithChildren<ContentWrapperProps>) => {
  return (
    <ContentWrapperStyles autoWidth={autoWidth} customSideMargin={customSideMargin}>
      {children}
    </ContentWrapperStyles>
  );
};
